import createTableStore from "ds/components/Table/store/useTableStore";

import {
  INTENT_PROJECT_HISTORY_COLUMN_CONFIG,
  INTENT_PROJECT_HISTORY_TABLE_STORAGE_KEY,
} from "./constants";

const useIntentProjectHistoryTableStore = createTableStore({
  storageKey: INTENT_PROJECT_HISTORY_TABLE_STORAGE_KEY,
  config: INTENT_PROJECT_HISTORY_COLUMN_CONFIG,
  version: 4,
});

export default useIntentProjectHistoryTableStore;
